import { useTranslation } from 'react-i18next';
import { MagnifyingGlassIcon, CaretDownIcon } from '@phosphor-icons/react';
import { DocumentStatus } from '@monorepo/shared';
import type { StatusFilter } from './documentTableTypes';

interface DocumentTableFiltersProps {
  searchQuery: string;
  statusFilter: StatusFilter;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: StatusFilter) => void;
  onReset: () => void;
}

export const DocumentTableFilters = ({
  searchQuery,
  statusFilter,
  onSearchChange,
  onStatusChange,
  onReset,
}: DocumentTableFiltersProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
      <div className="relative w-full sm:min-w-[220px] sm:max-w-xs sm:flex-1">
        <MagnifyingGlassIcon
          size={20}
          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
        />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={t('documents.search_placeholder')}
          className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
        />
      </div>

      <div className="flex flex-wrap items-center gap-3">
        <div className="relative">
          <select
            value={statusFilter}
            onChange={(e) => onStatusChange(e.target.value as StatusFilter)}
            className="appearance-none pl-4 pr-10 py-2 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-primary focus:border-transparent cursor-pointer"
          >
            <option value="all">{t('documents.table.filters.status')}</option>
            <option value={DocumentStatus.DRAFT}>{t('documents.table.status.not_started')}</option>
            <option value={DocumentStatus.PENDING_VALIDATION}>
              {t('documents.table.status.pending_validation')}
            </option>
            <option value={DocumentStatus.VALIDATED}>
              {t('documents.table.status.validated')}
            </option>
            <option value={DocumentStatus.DIFFUSED}>{t('documents.table.status.diffused')}</option>
          </select>
          <CaretDownIcon
            size={16}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none"
          />
        </div>

        <div className="relative">
          <select className="appearance-none pl-4 pr-10 py-2 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-primary focus:border-transparent cursor-pointer">
            <option>{t('documents.table.filters.update_date')}</option>
          </select>
          <CaretDownIcon
            size={16}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none"
          />
        </div>

        <button
          onClick={onReset}
          className="px-4 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:bg-opacity-90 transition"
        >
          {t('documents.table.filters.reset')}
        </button>
      </div>
    </div>
  );
};
